import { LINK_NHS_NOTIFY, LINK_SPI_GUIDANCE } from 'constants/links';

export interface HomePageCard {
  url: string;
  title: string;
  description: string;
  target?: string;
  rel?: string;
  ariaLabel?: string;
}

const homePageCards: HomePageCard[] = [
  {
    url: '/campaigns',
    title: 'Manage campaigns',
    description: 'Create, edit and review your campaigns.',
  },
  {
    url: LINK_NHS_NOTIFY,
    title: 'NHS Notify',
    description: 'Use this link to access NHS Notify to manage your message plans.',
    target: '_blank',
    rel: 'noopener noreferrer',
    ariaLabel: 'Open NHS Notify in new tab',
  },
  {
    url: LINK_SPI_GUIDANCE,
    title: 'SPI Guidance',
    description: 'This guide walks you through creating a campaign in SPI with confidence.',
    target: '_blank',
    rel: 'noopener noreferrer',
    ariaLabel: 'Open Guidance in new tab',
  },
];

export default homePageCards;
